import { render, staticRenderFns } from "./AboutUs_FR.vue?vue&type=template&id=16dd1623&scoped=true&"
import script from "./AboutUs_FR.vue?vue&type=script&lang=js&"
export * from "./AboutUs_FR.vue?vue&type=script&lang=js&"
import style0 from "./AboutUs_FR.vue?vue&type=style&index=0&id=16dd1623&prod&lang=css&"
import style1 from "./AboutUs_FR.vue?vue&type=style&index=1&id=16dd1623&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16dd1623",
  null
  
)

export default component.exports